import axios from 'axios';
import config from '../config';
import { store } from '../store';

const getHeaders = () => {
  const { authToken } = store.getState().user;
  return { authorization: authToken };
};

const ROSTER_BASE_BY_INSURER = {
  max:        '/max-users/agents',
  starhealth: '/starhealth/agents',
  icicilbd:   '/icicilbd/agents',
  abhi:       '/abhi/agents',
};

const baseFor = (insurer) => {
  const base = ROSTER_BASE_BY_INSURER[insurer];
  if (!base) {
    throw new Error(`[agentRoster service] Unsupported insurer: ${insurer}`);
  }
  return `${config.apiBaseUrl}${base}`;
};

export const getRoster = (insurer, agentType = 'doctor') =>
  axios
    .get(`${baseFor(insurer)}/roster`, {
      params:  { agent_type: agentType },
      headers: getHeaders(),
    })
    .then((r) => r.data);

export const promoteToTc = (insurer, agentId, reason) =>
  axios
    .post(
      `${baseFor(insurer)}/${agentId}/promote-to-tc`,
      { reason },
      { headers: getHeaders() }
    )
    .then((r) => r.data);

export const getAudit = (insurer, agentId, limit = 20) =>
  axios
    .get(`${baseFor(insurer)}/${agentId}/audit`, {
      params:  { limit },
      headers: getHeaders(),
    })
    .then((r) => r.data);
